import React, { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useLocation } from 'react-router-dom'

import { Button } from '@components/ui/button'
import Card from '@components/Card'
import { useTheme } from '@/components/ThemeProvider'

const StudentJoinShortCode = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { register, setValue, handleSubmit, formState: { errors } } = useForm()
  const { resolvedTheme } = useTheme()
  const inputRefs = useRef([])

  const onInputChange = (e, index) => {
    const nextInput = inputRefs.current[index + 1]

    if (e.target.value && nextInput) {
      nextInput.focus()
    }
  }

  const onSubmit = (data) => {
    const shortCode = data.shortCode.join('')
    let path = `/join_classroom/${shortCode}`

    // If current path includes '/students', prepend it (unless already present)
    if (location.pathname.includes('/students') && !path.startsWith('/students')) {
      path = `/students${path}`
    }

    navigate(path)
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <Card className="flex flex-col md:w-[450px] self-center p-5">
        <Choose>
          <When condition={resolvedTheme === 'dark'}>
            <img src="/brainstorm-board-dark.svg" alt="Brainstorming on a board" className="self-center w-[200px] h-[200px]" />
          </When>
          <Otherwise>
            <img src="/brainstorm-board.svg" alt="Brainstorming on a board" className="self-center w-[200px] h-[200px]" />
          </Otherwise>
        </Choose>

        <h1 className="text-2xl font-bold mt-3">Enter your join code</h1>

        <form
          onSubmit={handleSubmit(onSubmit)}>
          <div className="flex gap-3 mt-3">
            <For each="input" of={[1, 2, 3, 4, 5, 6]} index="index">
              <With field={register(`shortCode.${index}`, {
                required: true
              })}>
                <input
                  {...field}
                  ref={el => {
                    field.ref(el)
                    inputRefs.current[index] = el
                  }}
                  className="flex h-[50px] w-full rounded-md border border-input bg-background px-3 py-2 text-4xl text-center ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  key={index}
                  type="text"
                  maxLength="1"
                  autoCapitalize="none"
                  autoCorrect="off"
                  onPaste={e => {
                    e.preventDefault()

                    const paste = e.clipboardData.getData('text')
                    setValue('shortCode', paste)
                  }}
                  onChange={(e) => onInputChange(e, index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && e.target.value === '' && index > 0) {
                      inputRefs.current[index - 1].focus()
                    }
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      setValue(`shortCode.${index}`, e.target.value)
                      handleSubmit(onSubmit)()
                    }
                  }}
                />
              </With>
            </For>
          </div>

          <If condition={errors.shortCode}>
            <div className="mt-1 text-sm font-semibold text-red-500">
              Please provide a valid join code
            </div>
          </If>

          <Button
            className="w-full mt-5"
            type="submit"
            label="Next">
            Next
          </Button>
        </form>
      </Card>
    </div>
  )
}

export default StudentJoinShortCode
